import { BookingPolicyEnum } from '../../../shared/interfaces/RegisterPolicy.interface';

export const REFUND_ELIGIBILITY_FIELD = BookingPolicyEnum.RefundEligibility;

export const REFUND_ELIGIBILITY_OPTIONS = [
  {
    value: 'eligible_for_refund',
    labelKey:
      'BOOKING.QUOTATION_PAYMENT.refundEligibility.options.eligibleForRefund',
  },
  {
    value: 'eligible_redirected_reused',
    labelKey:
      'BOOKING.QUOTATION_PAYMENT.refundEligibility.options.eligibleRedirectedReused',
  },
  {
    value: 'not_eligible_duplicate_policy',
    labelKey:
      'BOOKING.QUOTATION_PAYMENT.refundEligibility.options.notEligibleDuplicatePolicy',
  },
] as const;

export type RefundEligibilityValue =
  (typeof REFUND_ELIGIBILITY_OPTIONS)[number]['value'];
